/**
 * The API base URL, read from /config.json at boot so nothing is baked into
 * the bundle (doc 02 STR-4). Adapted from Book&Host 69d7046: the Capacitor
 * branch and native Preferences storage wait for the iOS/Android apps (D-35).
 */
interface RuntimeConfig {
  apiUrl: string;
}

const DEFAULT_API_URL = '/api/v1';

let config: RuntimeConfig = { apiUrl: DEFAULT_API_URL };

declare global {
  interface Window {
    /** Test hook: Playwright may point the app at another API. */
    __MASTERDAY_API_URL__?: string;
  }
}

export async function initConfig(): Promise<RuntimeConfig> {
  if (typeof window !== 'undefined' && window.__MASTERDAY_API_URL__) {
    config = { apiUrl: window.__MASTERDAY_API_URL__ };
    return config;
  }
  try {
    const res = await fetch('/config.json');
    if (res.ok) {
      const data = (await res.json()) as Partial<RuntimeConfig>;
      if (typeof data.apiUrl === 'string' && data.apiUrl) {
        config = { apiUrl: data.apiUrl.replace(/\/$/, '') };
      }
    }
  } catch (err) {
    console.warn('Could not load /config.json, using the default API path:', err);
  }
  return config;
}

export function getConfig(): RuntimeConfig {
  return config;
}

/** For tests only. */
export function resetConfig(): void {
  config = { apiUrl: DEFAULT_API_URL };
}
